import { colors } from 'src/common/styles/colors';
import { mergeDeepRight } from 'ramda';
import { DefaultTheme } from 'styled-components';
import { shadows } from 'src/common/styles/shadows';
import tenantTheme from '@tenant/styles/theme';

export const theme: DefaultTheme = mergeDeepRight(
  { colors, shadows },
  tenantTheme
);
